"use strict";
import Account from "../api/account";
import ApiService from "../services/api_service";
import DataStoreService from "./data_store_service";
import { History } from "react-router";
import ToDashboardWithFilters from "./ui/to_dashboard_with_filters";
import LinkedStateMixin from "react-addons-linked-state-mixin";
import DocumentsService from "./documents_service";
import CarrierName from "./carrier_name";
import DisablingButton from "../components/disabling_button";
var EmailMergePage = React.createClass({
  mixins: [History, LinkedStateMixin],
  getInitialState: function() {
    return {
      emails: [],
      error: null,
      urlToAdd: null
    };
  },
  performMerge: function() {
    this.setState({ saving: true });
    return ApiService.addErrorHandler(
      $.post(
        "/api/email_messages/merge",
        { ids: this.emailMessageIds() }
      ).then(function(data) {
        DataStoreService.updateStores(data);
        this.onComplete();
      }.bind(this))
    ).catch(() => {
      this.setState({ saving: false });
    }).then(() => this.onComplete());
  },
  onComplete: function() {
    ToDashboardWithFilters(this.props.location, this.history);
  },
  performButton() {
    if (this.state.emails.length > 1) {
      return /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          className: "button--confirmation",
          disabled: this.state.saving,
          disabledText: "Merging...",
          onClick: this.performMerge
        },
        "Merge"
      );
    }
  },
  emailMessageIds() {
    return this.state.emails.map((e) => e.documentBatch.email_message.id);
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "row general-container reply-container" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 columns" }, /* @__PURE__ */ React.createElement("h2", null, "Merge Messages")), /* @__PURE__ */ React.createElement("div", { className: "small-10 columns" }, /* @__PURE__ */ React.createElement("div", { className: "email-merger__new-container" }, this.newEmailForm(), this.performButton()), /* @__PURE__ */ React.createElement("div", { className: "email-merger__existing-container" }, this.state.emails.map(this.showEmail))));
  },
  showEmail(email, position) {
    return /* @__PURE__ */ React.createElement("div", { className: "row", key: "email-" + email.documentBatchId }, /* @__PURE__ */ React.createElement("div", { className: "small-10 columns" }, this.showEmailDetail(email, position)));
  },
  showEmailDetail(email, position) {
    if (email.loading) {
      return /* @__PURE__ */ React.createElement("h3", null, "Loading...");
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: "email-merger__email-detail" }, /* @__PURE__ */ React.createElement("h3", null, "Message ", position + 1, " [", this.removeLink(email), "]"), this.emailTable(email));
    }
  },
  emailTable(email) {
    const message = email.documentBatch.email_message;
    const table = [
      ["Subject", message.subject],
      ["Sender", message.sender_address],
      [Account.carrierTerm(), /* @__PURE__ */ React.createElement(
        CarrierName,
        {
          carrierID: message.carrier_id,
          multiple: !message.single_carrier
        }
      )]
    ];
    return table.map(this.tableEntry);
  },
  removeLink(email) {
    return /* @__PURE__ */ React.createElement("a", { onClick: () => this.removeEmail(email) }, "X");
  },
  removeEmail(email) {
    this.setState({ emails: this.state.emails.filter((e) => e != email) });
  },
  tableEntry(pair) {
    return /* @__PURE__ */ React.createElement("div", { className: "row", key: "table-" + pair[0] }, /* @__PURE__ */ React.createElement("div", { className: "small-1 columns" }, pair[0]), /* @__PURE__ */ React.createElement("div", { className: "small-9 columns" }, pair[1]));
  },
  newEmailForBatchId(batchId) {
    return {
      documentBatchId: batchId,
      loading: true
    };
  },
  startLoadingEmail(newEmail) {
    DocumentsService.getDocumentBatch(newEmail.documentBatchId).then((batch) => {
      newEmail.documentBatch = batch;
      newEmail.loading = false;
      this.setState({ emails: this.state.emails });
    });
  },
  hasExisting(batchId) {
    return this.state.emails.some((e) => e.documentBatchId == batchId);
  },
  addUrl() {
    const match = this.state.urlToAdd.match(/index-document-batches\/(\d+)/);
    if (match) {
      if (this.hasExisting(match[1])) {
        this.setState({ errors: "Message already added." });
      } else {
        const newEmail = this.newEmailForBatchId(match[1]);
        this.setState({
          emails: this.state.emails.concat([newEmail]),
          urlToAdd: null,
          errors: null
        }, () => this.startLoadingEmail(newEmail));
      }
    } else {
      this.setState({
        errors: "Unable to find email in URL. It should look like:'https://www.hubtran.com/app/index-document-batches/123...'"
      });
    }
  },
  newEmailForm() {
    return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 large-5 columns" }, /* @__PURE__ */ React.createElement("label", null, "Paste URL to email here", /* @__PURE__ */ React.createElement("div", { className: "row collapse" }, /* @__PURE__ */ React.createElement("div", { className: "small-8 columns" }, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "text",
        valueLink: this.linkState("urlToAdd")
      }
    )), /* @__PURE__ */ React.createElement("div", { className: "small-2 columns" }, /* @__PURE__ */ React.createElement(
      "a",
      {
        onClick: this.addUrl,
        className: "email-merger__go-button button postfix"
      },
      "Add"
    )), this.errorDisplay()))));
  },
  errorDisplay() {
    if (this.state.errors) {
      return /* @__PURE__ */ React.createElement("small", { className: "error" }, this.state.errors);
    }
  }
});
export default EmailMergePage;
